<template >
  <Modal v-bind="$attrs" @cancel="$emit('cancel')" @confirm="onConfirm" @close="onModalClose" @open="onModalOpen">
    <el-form
      v-if="budgetForm"
      class="ghost-button-styles"
      ref="bidForm"
      @submit.native.prevent
      :model="budgetForm"
      :rules="rules"
      label-width="120px"
    >
      <BidAndOptGoal v-model="budgetForm" :plan-form="planForm"></BidAndOptGoal>
    </el-form>
  </Modal>
</template>
<script>
import { clone } from '@/common/js/just.js'
import Modal from './modal.vue'
import BidAndOptGoal from '../../../components/budget/bid-goal.vue'
import budgetFormRules from '@/views/create/gdt/model/budget/budget-rules.js'
export default {
  components: { Modal, BidAndOptGoal },
  props: {
    currentRow: Object
  },
  provide() {
    return {
      parentInstance: this
    }
  },

  data() {
    return {
      rules: budgetFormRules.call(this),
      budgetForm: null
    }
  },
  computed: {
    planForm() {
      return this.currentRow?.plan && clone(this.currentRow.plan)
    }
  },

  methods: {
    onModalOpen() {
      this.budgetForm = clone(this.currentRow?.bid)
    },
    onModalClose() {
      this.budgetForm = null
    },
    onConfirm() {
      this.$refs.bidForm.validate().then((valid) => {
        if (valid) {
          this.$emit('confirm', this.budgetForm)
          this.$nextTick(this.onModalClose)
        }
      })
    }
  }
}
</script>
